module.exports = __webpack_public_path__ + "img/inventory-mobile.54c3ee66.svg";